// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@awc/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { rfqMyQuotesFilterStyles } from "@awc/Overrides/Widgets/RfqMyQuotes/RfqMyQuotesFilter";
import { mergeWithCss } from "@awc/XDL/Utilities";
import { css } from "styled-components";

rfqMyQuotesFilterStyles.container = {
    ...myAccountFilterSectionStyles.filterContainer,
    offsetCss: css`
        align-items: end;
    `,
};

rfqMyQuotesFilterStyles.headingItem = {
    css: css`
        display: none;
    `,
};

rfqMyQuotesFilterStyles.fromGridItem =
    rfqMyQuotesFilterStyles.toGridItem =
    rfqMyQuotesFilterStyles.expireFromGridItem =
    rfqMyQuotesFilterStyles.expireToGridItem =
        {
            width: [12, 12, 6, 2, 2],
            css: css`
                > div {
                    display: flex;
                    width: 100%;
                }
            `,
        };

rfqMyQuotesFilterStyles.customerGridItem = {
    width: [12, 12, 12, 2, 2],
};

rfqMyQuotesFilterStyles.salesRepGridItem = {
    width: [12, 12, 12, 2, 2],
};

rfqMyQuotesFilterStyles.userGridItem = {
    width: [12, 12, 12, 2, 2],
};

rfqMyQuotesFilterStyles.quoteNumberGridItem = {
    width: [12, 12, 12, 2, 2],
};

rfqMyQuotesFilterStyles.clearFiltersButton = {
    ...myAccountFilterSectionStyles.clearButton,
};

rfqMyQuotesFilterStyles.appliedFiltersContainer = {
    ...myAccountFilterSectionStyles.appliedFiltersContainer,
};

rfqMyQuotesFilterStyles.appliedFilterTag = {
    ...myAccountFilterSectionStyles.appliedFilterTag,
};

rfqMyQuotesFilterStyles.buttonsItem = {
    width: [12, 12, 12, 2, 2],
    css: css`
        &&& {
            justify-content: flex-end;
            align-items: flex-end;
            margin-left: auto;
        }
    `,
};

rfqMyQuotesFilterStyles.expireFromDate = rfqMyQuotesFilterStyles.fromDate = {
    ...mergeWithCss(myAccountFilterSectionStyles.fromDate, {
        cssOverrides: {
            formInputWrapper: css`
                &&& {
                    .react-datetime-picker {
                        min-height: 42px;
                    }
                }
            `,
        },
    }),
};

rfqMyQuotesFilterStyles.expireToDate = rfqMyQuotesFilterStyles.toDate = {
    ...mergeWithCss(myAccountFilterSectionStyles.toDate, {
        cssOverrides: {
            formInputWrapper: css`
                &&& {
                    .react-datetime-picker {
                        min-height: 42px;
                    }
                }
            `,
        },
    }),
};

rfqMyQuotesFilterStyles.largeGridItem = {
    width: [12, 12, 12, 4, 4],
};

rfqMyQuotesFilterStyles.quoteStatusTypeGridItem = {
    width: [12, 12, 12, 2, 2],
};
